export const responseStatus = {
  SUCCESS: 200,
  NOCONTENT: 204,
  BADREQUEST: 400,
  UNAUTHORIZED: 401,
  UNAUTHORIZED_PROXY: 407,
  FORBIDDEN: 403,
  ANOTHERLOGIN: 405,
  REQUESTTIMEOUT: 408,
  RequestTookMoreThanExpected: 429,
  INTERNALSERVERERROR: 500
};
